module.exports = __webpack_public_path__ + "static/media/Verified Jira account.d8666f6b.svg";